import * as UserActionCreate from './user';

export default {
  ...UserActionCreate,
};
